import IActionType from '../interfaces/IActionType';
import * as actionTypes from './actionTypes';

export const deveCarregarInscricaoNaMemoria = (deveCarregarInscricaoNaMemoria: boolean): IActionType<boolean> => ({
  type: actionTypes.DEVE_CARREGAR_INSCRICAO_NA_MEMORIA,
  state: deveCarregarInscricaoNaMemoria
});